import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FaYoutube } from 'react-icons/fa';

const youtubeUrl = 'https://www.youtube.com/c/XipandzaMananga?sub_confirmation=1';

const links = [
  { to: '/', label: 'Home' },
  { to: '/travel', label: 'Travel' },
  { to: '/portfolio', label: 'Gallery' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];

const navLinkClass = ({ isActive }) =>
  `rounded-lg px-3 py-2 text-sm font-bold transition ${
    isActive
      ? 'bg-white text-stone-950'
      : 'text-stone-100 hover:bg-white/10 hover:text-white'
  }`;

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <nav className="fixed left-0 top-0 z-50 w-full border-b border-white/10 bg-stone-950/92 text-white shadow-lg backdrop-blur">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 lg:px-8">
        <NavLink to="/" onClick={closeMenu} className="flex min-w-0 items-center gap-3">
          <img src="/logo.png" alt="Xipandza Mananga Travel logo" className="h-12 w-auto flex-none" loading="eager" />
          <span className="min-w-0">
            <span className="block truncate text-base font-black leading-5 sm:text-lg">
              Xipandza Mananga
            </span>
            <span className="block text-xs font-bold uppercase tracking-[0.2em] text-[#F6B35E]">
              Travel
            </span>
          </span>
        </NavLink>

        <button
          type="button"
          onClick={() => setIsMenuOpen((open) => !open)}
          className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-white/20 text-white lg:hidden"
          aria-label="Toggle navigation menu"
          aria-expanded={isMenuOpen}
        >
          <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            {isMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 7h16M4 12h16M4 17h16" />
            )}
          </svg>
        </button>

        <div className="hidden items-center gap-2 lg:flex">
          {links.map((link) => (
            <NavLink key={link.to} to={link.to} className={navLinkClass}>
              {link.label}
            </NavLink>
          ))}
          <a
            href={youtubeUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="ml-2 inline-flex items-center gap-2 rounded-lg bg-[#D96098] px-3 py-2 text-sm font-bold text-white transition hover:bg-[#c64f85]"
          >
            <FaYoutube className="h-4 w-4" aria-hidden="true" />
            YouTube
          </a>
        </div>
      </div>

      {isMenuOpen ? (
        <div className="border-t border-white/10 bg-stone-950 px-5 pb-5 pt-2 lg:hidden">
          <div className="mx-auto grid max-w-7xl gap-1">
            {links.map((link) => (
              <NavLink key={link.to} to={link.to} onClick={closeMenu} className={navLinkClass}>
                {link.label}
              </NavLink>
            ))}
            <a
              href={youtubeUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-lg bg-[#D96098] px-3 py-3 text-sm font-bold text-white"
            >
              <FaYoutube className="h-4 w-4" aria-hidden="true" />
              YouTube Channel
            </a>
          </div>
        </div>
      ) : null}
    </nav>
  );
};

export default Navbar;
